import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconTravellerStatusCompleted(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <circle cx="12" cy="12" r="7" fill="#05BA8C" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5104 9.20041C15.8139 9.48226 15.8315 9.95681 15.5496 10.2603L10.6746 15.5103C10.5279 15.6683 10.3204 15.7555 10.1049 15.7497C9.88943 15.744 9.68685 15.6457 9.54885 15.4801L7.67385 13.2301C7.40868 12.9119 7.45167 12.439 7.76988 12.1738C8.08809 11.9087 8.56101 11.9517 8.82618 12.2699L10.1555 13.865L14.4504 9.23966C14.7323 8.93613 15.2068 8.91856 15.5104 9.20041Z"
        fill="white"
      />
    </BaseIcon>
  );
}
